import axios from 'axios'
axios.defaults.baseURL = 'http://111.229.214.104:8000'


const state = {
home1:[],
home2:'',
home3:[],
getList:[],
getAlls:[]
}

const mutations = {
GET_HOME1 (state, contents) {
    state.home1 = contents
  },
GET_HOME2 (state, logImage) {
    state.home2 = logImage
  },
GET_HOME3 (state, posterImage) {
    state.home3 = posterImage
localStorage.setItem("bar",state.home3)
},
// 获取列表的信息
GET_PRODUCT_LIST (state,data) {
  state.getList = data
},
// 获取推荐
GET_All (state,data) {
  state.getAlls = data
}
}

const actions = {
  // 主页数据
	getHome ({ commit }) {
		axios.get('/index/').then((response) => {
			commit('GET_HOME1',response.data.context.contents)
      commit('GET_HOME2',response.data.context.logo_image.logo_image)
      commit('GET_HOME3',response.data.context.poster_image)
		})
	},
  // 推荐
  getAll ({ commit }) {
    axios.get('/index/?id=0').then((response) => {
      commit('GET_All',response.data.context.contents)
      // console.log(response.data.context.contents)
    })
  },
  getproductList ({commit},cur) {
    axios.get('/index/?id='+ cur).then((response) => {
      commit('GET_PRODUCT_LIST',response.data.context.contents)
      // console.log(response.data.context.contents)
    })
  },
}

const getters = {
nide(state) {
  let getList = state.getList;
  getList.sort((a,b) => {
    return  b.read_num - a.read_num
  });
}
}

const HomeModule = {
  state,
  mutations,
  actions,
  getters
}

export default HomeModule
